'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppForm = function () {
    function AppForm(block) {
        _classCallCheck(this, AppForm);

        this.block = block;
        this.init();
    }

    _createClass(AppForm, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.nameInput = this.block.querySelector('.app-form__input_name');
            this.phoneInput = this.block.querySelector('.app-form__input_phone');
            this.selectInput = this.block.querySelector('.app-form__input_select');
            this.datetimepicker = this.block.querySelector('#datetimepicker');

            new IMask(this.phoneInput, {
                mask: '+{7} (000) 000 - 00 - 00'
            });

            this.nameInput.addEventListener('input', function (e) {
                return _this.onInput(e);
            });
            this.phoneInput.addEventListener('input', function (e) {
                return _this.onInput(e);
            });

            var parent = this.selectInput.parentNode;
            var newSelect = this.selectInput.parentNode.innerHTML;

            var parentDOMNodeInsertedEvent = function parentDOMNodeInsertedEvent() {
                parent.removeEventListener('DOMNodeInserted', parentDOMNodeInsertedEvent, true);
                var select = parent.querySelector('select');
                $(select).select2({
                    minimumResultsForSearch: -1,
                    containerCssClass: 'app-form__select',
                    dropdownCssClass: 'app-form__select-d'
                });
            };

            parent.addEventListener('DOMNodeInserted', parentDOMNodeInsertedEvent, true);

            parent.innerHTML = newSelect;

            jQuery.datetimepicker.setLocale('ru');

            this.block.addEventListener('submit', function (e) {
                return _this.onSubmit(e);
            });
        }
    }, {
        key: 'onInput',
        value: function onInput(e) {
            e.target.classList.remove('error');
        }
    }, {
        key: 'validateInput',
        value: function validateInput(input, length) {
            if (input.value.length >= length) {
                return true;
            }
            input.classList.add('error');
            return false;
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            var valid = this.validateInput(this.nameInput, 2) && this.validateInput(this.phoneInput, 22);

            if (!valid) {
                return;
            }

            var data = {};
            var formData = new FormData(this.block);

            formData.forEach(function (value, key) {
                data[key] = value;
            });

            console.log(data);
        }
    }]);

    return AppForm;
}();

var appForms = [].slice.call(document.querySelectorAll('.app-form'));

appForms.forEach(function (appForm) {
    return new AppForm(appForm);
});
